module.exports = __webpack_public_path__ + "static/henho4-c909bf8593883960a3b90efc5da62b64.jpg";